import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { Props } from './RestoreTrashbinFilesThanksModal.types';

export const renderRestoreTrashbinFilesThanksModal = (data: Props) => {
    openPopupHelper({ popupName: popupNames.RESTORE_TRASHBIN_FILES_THANKS_MODAL, data, onClose: data.onClose });
};
